import React from 'react';
import { DatePickerStateProvider, IDatePickerSateParams } from './DatePickerStateProvider';
import { StyledDateRangeInput } from 'containers/BookingList/StyledFilters';
import { format } from 'date-fns';
import { generateArrayOfDatesBetween } from 'utils';

interface IDatePickerWrapperProps {
  calendarCount?: number;
  dateRange?: {
    startDate?: string;
    endDate?: string;
  };
  onDateChange: (startDate: string, endDate: string) => void;
}

export const DatePickerWrapper: React.FC<IDatePickerWrapperProps> = ({
  dateRange,
  onDateChange,
  calendarCount = 2,
}) => {
  const selectedDates =
    dateRange?.startDate && dateRange?.endDate
      ? generateArrayOfDatesBetween(dateRange.startDate, dateRange.endDate).map(d => `${d}T00:00:00.000Z`)
      : [];

  const handleDateChange = (dates: string[]) => {
    const startDate = format(new Date(dates[0]), 'yyyy-MM-dd');
    const endDate = format(new Date(dates[dates.length - 1]), 'yyyy-MM-dd');
    onDateChange(startDate, endDate);
  };

  return (
    <DatePickerStateProvider
      defaultSelectedDates={selectedDates}
      onDateChange={handleDateChange}
      render={(params: IDatePickerSateParams) => {
        const placeHolder = 'Select Dates...';
        const dates = !params.dateSelectionInProgress && !dateRange ? [] : params.selectedDates;
        const displayString = !dateRange ? placeHolder : params.displayString;

        return (
          <StyledDateRangeInput
            displayString={displayString}
            currentDate={params.datePickerCurrentDate}
            selectedDates={dates}
            onDayClick={params.handleDayClick}
            onDayMouseOver={params.handleDateMouseOver}
            showDatePicker={params.showDatePicker}
            onNextClick={params.incrementDate}
            onPrevClick={params.decrementDate}
            onMouseDown={params.toggleDatePicker}
            onClickOutside={params.hideDatePicker}
            placeholder={placeHolder}
            showTotalNights={false}
            showCalendarIcon
            calendarCount={calendarCount}
            enablePastDates
            noPortal
          />
        );
      }}
    />
  );
};
